import { OPEN_MODAL, CLOSE_MODAL } from '../actions/modal_actions.js';

export default function modalReducer(state = null, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return {component: action.modal, props: action.props};
    case CLOSE_MODAL:
      return {component: null, props: null};
    default:
      return state;
  }
}